import React from 'react'
import IntroLogo from './IntroLogo'
import '../../styles/WelcomeSection/WelcomeHeader.scss'
import neilImage from '../../static/images/neil.png'

const WelcomeHeader = () => {
  return (
        <header>
            <h2 className="funnel_header">
                Success! We&apos;ve found your fiduciary advisor matches.
            </h2>
            <div className="intro">
                <img src={neilImage} alt="Neil picture" title="Neil" className="intro_avatar" />
                <div className="intro_content">
                    <IntroLogo />
                    <p className="intro_text">
                        Hi I&apos;m Neil, Concierge Manager at SmartAsset. My team is here to discuss your advisor matches and help in your search for the
                        right financial partner. Here&apos;s what to expect next:
                    </p>
                </div>
            </div>
        </header>
  )
}

export default WelcomeHeader
